import { useState, useCallback } from "react";
import { useAppDispatch } from "../../../../redux/store";
import {
  getDropboxTemporaryLink,
  getDropboxPreview,
  getDropboxThumbnail,
} from "../../../../redux/slices/dropboxFoldersSlice";
import {
  isPdfFile,
  isVideoFile,
  isPreviewableAsPdf,
  isPreviewableAsHtml,
} from "./useFileOperations";

export const useThumbnailOperations = () => {
  const dispatch = useAppDispatch();
  const [thumbnailPreviewOpen, setThumbnailPreviewOpen] = useState(false);
  const [selectedThumbnailFile, setSelectedThumbnailFile] = useState<any>(null);

  const handleThumbnailClick = useCallback(
    (file: any) => {
      if (file.type === "file" && file.path) {
        setSelectedThumbnailFile(file);
        setThumbnailPreviewOpen(true);

        // For PDF files, use temporary link action to get the PDF URL
        if (isPdfFile(file.name)) {
          dispatch(getDropboxTemporaryLink({ filePath: file.path }));
        } else if (isVideoFile(file.name)) {
          // For video files, use temporary link to get the video URL
          dispatch(getDropboxTemporaryLink({ filePath: file.path }));
        } else if (
          isPreviewableAsPdf(file.name) ||
          isPreviewableAsHtml(file.name)
        ) {
          // For files that can be previewed via Dropbox API
          dispatch(getDropboxPreview({ filePath: file.path }));
        } else {
          // For images: fetch both the large thumbnail AND the temporary link (full-res fallback)
          dispatch(
            getDropboxThumbnail({ filePath: file.path, size: "w1024h768" })
          );
          dispatch(getDropboxTemporaryLink({ filePath: file.path }));
        }
      }
    },
    [dispatch]
  );

  const closeThumbnailPreview = useCallback(() => {
    setThumbnailPreviewOpen(false);
    setSelectedThumbnailFile(null);
  }, []);

  const resetThumbnailState = useCallback(() => {
    setThumbnailPreviewOpen(false);
    setSelectedThumbnailFile(null);
  }, []);

  return {
    thumbnailPreviewOpen,
    selectedThumbnailFile,
    handleThumbnailClick,
    closeThumbnailPreview,
    resetThumbnailState,
  };
};
